import React from "react";
import PageRenderer from "../components/PageRender";

const Contatti = () => {
  return <PageRenderer pageIdentifier="pagina-dei-contatti" />;
};

export default Contatti;
